<template>
    <span class="text-center">
      <v-btn :dark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().accentCode" small text outlined  @click="dialog=!dialog" >
        {{ $store.getters.getTextMap().create_ethernetip_device }}<v-icon  right :isDark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().btnborderColorCode" small>mdi-dots-square</v-icon>
        </v-btn>
           <v-bottom-sheet v-model="dialog">
        <v-sheet
      :dark="$store.getters.getColorPalette().isDark"
          class="text-center"
           :style="{background: $store.getters.getColorPalette().backgroundColorCode, color:$store.getters.getColorPalette().accentcode}"
        >
        <CreateEthernetIPDevice :workspace="workspace"  v-on:close="dialog=false"/>
        </v-sheet>
      </v-bottom-sheet>
  
    </span>
    
  </template>
  
  <script>
  import CreateEthernetIPDevice from '@/components/crud_components/engineering/CreateEthernetIPDevice'
   export default {
       name:'CreateEthernetIPDeviceModal',
       props:['workspace'],
       components:{
        CreateEthernetIPDevice
       },
       data(){
           return {
               dialog:false
           }
       }
   }
   </script>
